<ifb-card>
  <mat-card appearance="raised">
    <mat-card-header>
      <mat-card-title>
        Total draws
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ifb-line-chart [options]="chartData.options"
                      [view]="chartData.view"
                      [data]="chartData.data">
      </ifb-line-chart>
    </mat-card-content>
  </mat-card>
</ifb-card>
